import React from 'react'


interface FormButtonProps {
    children: React.ReactNode
    type: "button" | "submit" | 'reset'
    disabled?: boolean
}

export const FormButton = (props: FormButtonProps) => {

    return (
        <button
            type={props.type ?? 'button'}
            disabled={props.disabled}
            className={`group relative flex w-full justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-primary-400 focus:ring-offset-2 transition-all duration-200 shadow-sm ${
                props.disabled 
                    ? 'bg-primary-300 cursor-not-allowed' 
                    : 'bg-primary-500 hover:bg-primary-600 hover:shadow-md'
            }`}
        >
            {props.children}
        </button>
    )
}
